export const state = {
  routes: [],
  config: [],
  pageCount: 0,
  itemCount: 0,
}
